import { IRateOurEstimationState, ERateScreen } from '../../types/redux/rateOurEstimation';
import { TReduxActions } from '../../types/redux';
import { ERateOurEstimationActions } from '../../constants/actionTypes/rateOurEstimation';

export const defaultState = {
  isScoreFact: false,
  isOpen: false,
  screen: ERateScreen.Form,
};

export function rateOurEstimationReducer(state: IRateOurEstimationState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case ERateOurEstimationActions.SET_COMMENT:
      return {
        ...state,
        comment: action.payload,
      };

    case ERateOurEstimationActions.SET_IS_SCORE_FACT:
      return {
        ...state,
        isScoreFact: action.payload,
      };

    case ERateOurEstimationActions.SET_RATE_OUR_ESTIMATION:
      return {
        ...state,
        rateOurEstimationValue: action.payload,
      };

    case ERateOurEstimationActions.SET_USER_PRICE:
      return {
        ...state,
        userPrice: action.payload,
      };

    case ERateOurEstimationActions.TOGGLE_MODAL:
      return {
        ...state,
        isOpen: action.payload,
      };

    case ERateOurEstimationActions.TOGGLE_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case ERateOurEstimationActions.SET_SCREEN:
      return {
        ...state,
        screen: action.payload,
      };

    case ERateOurEstimationActions.TOGGLE_LOADING_BLOCK:
      return {
        ...state,
        isLoadingBlock: action.payload,
      };

    default:
      return state;
  }
}
